import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Button } from "@emisgroup/ui-button";
import { Environments } from "@emisgroup/cohort-builder-kit";
import { IRootState } from "../../../reducer/CombineReducer";
import { ButtonVariantType } from "../../Common/UI/Types";
import { useUser } from "../../../AuthContext";
import { GetSelectedExtractDetail } from "../Versioning/GetVersions/helper";
import { OptOut } from "./OptOut";
import { HandleSaveMetaData } from "./Scripts";
import { OptOutModes, ParentOptOutModes } from "./redux/Types";
import { OptOutSlice } from "./redux/Index";
import { CHILD, OPTOUTS } from "./Constant";
import "./Style.scss";

/**
 * Responsible for optOut Component
 * @returns JSX Element
 */
export const OptOutSaveButton = (): JSX.Element => {
  const { t: translate } = useTranslation();
  const dispatch = useDispatch();
  const [
    optOut,
    partition,
  ] = useSelector((state: IRootState) => [
    state.optOut,
    state.partition,
  ], shallowEqual);
  const currentValues = optOut?.selectedOptOuts;
  const isEditMode = optOut?.mode === ParentOptOutModes.EDIT;
  const selectedArtefactId = partition?.selectedId as string;
  const { user } = useUser();
  const disableSave = currentValues?.length === 0;
  const isViewMode = optOut.mode === ParentOptOutModes.VIEW;

  /**
   * Method for clicking cancel
   */
  const goBack = (): void => {
    dispatch(OptOutSlice.actions.setOptOutMode(ParentOptOutModes.VIEW));
    GetSelectedExtractDetail(
      dispatch,
      selectedArtefactId,
      translate,
      user?.token
    );
  };

  /**
   * On click method for save meta data
   */
  const onClickSave = (): void => {
    const payload = {
      key: OPTOUTS,
      value:{
        type: CHILD,
        selection: {
          explorer_ipcv_vanilla: currentValues
        }
      }
    };

    const savePayload = {
      metaData: [payload]
    };

    HandleSaveMetaData(
      isEditMode? payload : savePayload as any,
      process.env.APP_TARGET_ENV as Environments,
      user?.token,
      selectedArtefactId,
      dispatch,
      translate,
      isEditMode ? OptOutModes.UPDATE : OptOutModes.SAVE,
    );
  };

  return (
    <>
      <OptOut />
      {!isViewMode &&
      <div className="ebt-optOut__footer">
        <Button
          id="ebt-optOut-cancel"
          borderless={true}
          onClick={goBack}
        >
          {translate("Button.Cancel")}
        </Button>
        <Button
          id="ebt-optOut-save"
          variant={ButtonVariantType.FILLED}
          onClick={onClickSave}
          disabled={disableSave}
        >
          {translate("Button.Save")}
        </Button>
      </div>
      }
    </>
  );
};
